export type ThemeChoice = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'fw-theme';
const media = () => window.matchMedia('(prefers-color-scheme: dark)');

/** The browser bar color for each theme (the page background, docs/DESIGN.md). */
const THEME_COLOR = { light: '#F4EFE6', dark: '#0E0E0F' } as const;

export function getThemeChoice(): ThemeChoice {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {
    // Storage blocked (private mode): fall back to the device setting.
  }
  return 'system';
}

function apply(choice: ThemeChoice) {
  const theme = choice === 'dark' || (choice === 'system' && media().matches) ? 'dark' : 'light';
  document.documentElement.dataset.theme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLOR[theme]);
}

export function setThemeChoice(choice: ThemeChoice): void {
  try {
    if (choice === 'system') window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, choice);
  } catch {
    // Not remembered, but still applied for this visit.
  }
  apply(choice);
}

/** Applies the saved choice (or the device setting) and follows device changes in "system" mode. */
export function initTheme(): void {
  apply(getThemeChoice());
  media().addEventListener('change', () => apply(getThemeChoice()));
}
